import Cookies from 'js-cookie'
export const myFavoritesInit = () => {
	if (document.cookie.indexOf('logonMFB') > -1) {
		$.ajax({
			url: '/wcs/resources/store/301/myFavoriteBrands',
			type: 'GET',
			dataType: 'json',
			success: function (response) {
				try {
					if (typeof response === 'object' && response.response.Favorite.length > 0) {
						const categories = response.response.Favorite;
						categories.forEach((category) => {
							let categoryID = category.categoryNum;
							localStorage.setItem(`myFavoritespersonalization${categoryID}`, JSON.stringify(category.brands));
						});
						Cookies.remove('logonMFB');
						Cookies.remove('logonMFB', { path: '/', domain: '.' + window.location.hostname });
					}
				} catch (e) {
					console.log(e);
				}
			},
			error: (jqXHR) => {
				try {
					let userInfo = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
					let errorToSend = [];
					let thisError = { eventType: 'call myFavoriteBrands', eventText: 'call failed' };
					thisError.eventData = {};
					thisError.eventData.error = jqXHR.responseJSON;
					thisError.eventData.userId = userInfo !== null ? userInfo.userId : 'null';
					errorToSend.push(thisError);

					const xhttp = new XMLHttpRequest();
					xhttp.open('POST', window.location.protocol + '//' + window.location.host + '/wcs/resources/store/301/logging/info', true);
					xhttp.send(JSON.stringify(errorToSend));
				} catch (e) {
					console.log(e);
				}
			},
		});
	}
};
